export type folderManagementFilterSliceState = {
  // folderName: string;
  // pageNumber: number;
  fmActiveTab: string;
  fmActiveTabFolderCount: number;
  fmNestedTab: string;
  fmNestedActiveTabFolderCount: number;
  stateName: string;
  nestedStateName: string;
  currentState: number | number[];
};

export const folderManagementFilterSliceInitialState: folderManagementFilterSliceState =
  (() => {
    return {
      // folderName: "",
      // pageNumber: 0,
      fmActiveTab: "In Pipeline",
      fmActiveTabFolderCount: 0,
      fmNestedTab: "",
      fmNestedActiveTabFolderCount: 0,
      stateName: 'inPipeline',
      nestedStateName: '',
      currentState: 0
    };
  })();
